import { useEffect, useState } from "react";
import axios from "../api/axiosInstance";

export default function useTherapistRoster() {
  const [therapists, setTherapists] = useState([]);
  const [rosterLoading, setRosterLoading] = useState(true);
  const [rosterError, setRosterError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    axios.get("/api/therapists", { signal: controller.signal })
      .then(({ data }) => {
        if (!data.success || !Array.isArray(data.therapists)) {
          throw new Error("Invalid therapist directory");
        }
        if (!controller.signal.aborted) {
          setTherapists(data.therapists);
        }
      })
      .catch(() => {
        if (!controller.signal.aborted) {
          setRosterError("Unable to load therapists. Please reload to try again.");
        }
      })
      .finally(() => {
        if (!controller.signal.aborted) setRosterLoading(false);
      });
    return () => controller.abort();
  }, []);

  return { therapists, rosterLoading, rosterError };
}
